function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Gdzie wyrzuci\u0107");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h65v65H0z",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.001 48a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5zm0-8a3 3 0 0 0 0 6 3 3 0 0 0 0-6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M46.656 55H18.245A2.194 2.194 0 0 1 16 53l-4-42h41l-4 42a2.289 2.289 0 0 1-2.344 2zM14 13l3.922 39.7a.324.324 0 0 0 .324.3h28.352a.324.324 0 0 0 .324-.3L51 13z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 15)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.001 14.989a1.028 1.028 0 0 1-.852-.513.973.973 0 0 1-.01-.974l4.026-7.011a.978.978 0 0 1 .841-.495.864.864 0 0 1 .85.478l4.023 7.028a.974.974 0 0 1-.83 1.471l-8.048.016zm4-6l-2.3 4h4.536z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 21a10 10 0 1 1 10-10 9.941 9.941 0 0 1-10 10zm0-18a8.246 8.246 0 0 0-8 8 8.246 8.246 0 0 0 8 8 8.246 8.246 0 0 0 8-8 8.246 8.246 0 0 0-8-8z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 12,
  rx: 1,
  transform: "rotate(-45 28.955 -10.775)"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.001 48.989a1.028 1.028 0 0 1-.852-.513.973.973 0 0 1-.01-.974l4.026-7.011a.978.978 0 0 1 .841-.495.864.864 0 0 1 .85.478l4.023 7.028a.974.974 0 0 1-.83 1.471l-8.048.016zm4-6l-2.3 4h4.536z"
});

var SvgGdzieWyrzucic = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGdzieWyrzucic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gdzieWyrzucic.30aa3642.svg";
export { ForwardRef as ReactComponent };